import { AT_LIST_VIEW_ACTION_SET } from './constants';
import { TListViewBoardAction } from '../../listViewBoard/actions/types';
import { IListViewActionSetAction } from './types';
import { TBoardId } from '../../../../../../types/types';

export const listViewActionSet = (
    boardId: TBoardId,
    listViewAction: TListViewBoardAction
): IListViewActionSetAction => ({
        type: AT_LIST_VIEW_ACTION_SET,
        boardId,
        listViewAction
    }
);
